import { styled } from '@mui/material';
import React from 'react';
import { channelDetail } from '../../../../shared/constants';
import { CheckCircleOutline } from '@mui/icons-material';

export const DropdownStoreItemStyle = styled('div')<{ selected?: boolean }>(({ selected }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: selected ? '8px 12px' : 'unset',
  cursor: 'pointer',
  fontSize: '12px',

  '& .title-store-item': {
    flexGrow: 1,
    // elisis for long text
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    maxWidth: '300px'
  },

  ...(selected ? {
    '&:hover': {
      backgroundColor: '#f5f5f5',
    }
  } : {}),
}));

interface StoreItem {
  is_downloaded?: boolean;
  total_downloaded?: number;
  all_product?: number;
  channel_id: number;
  store_name: string;
  store_id: number;
  on_download_process: boolean;
}

interface DropdownStoreItemProps<T extends StoreItem = StoreItem> {
  channelId?: number;
  label?: string;
  item?: T;
  isItem?: boolean;
  onClick?: () => void;
}

const DownloadStoreStatus = ({
  is_downloaded,
}) => {
  if (is_downloaded) return <CheckCircleOutline fontSize="medium" style={{ color: '#4CAF50', marginLeft: '10px' }} />
  return null
}

export const DropdownStoreItem = <T extends StoreItem = StoreItem>({
  channelId,
  label,
  item,
  isItem = false,
  onClick
}: DropdownStoreItemProps<T>) => {
  return (
    <DropdownStoreItemStyle selected={isItem} onClick={() => {
      if (onClick) onClick();
    }}>
      {item ? (
        <>
          <img
            src={channelDetail[item.channel_id]?.channelLogo || null}
            alt="logo_mp_64"
            style={{
              width: '15px',
              height: 'auto',
              marginRight: '8px'
            }}
          />
          <span className="title-store-item">{item.store_name}</span>
          {isItem
            && item.total_downloaded
            && item.all_product ? <span>{item.total_downloaded} / {item.all_product}</span> : null}
          {isItem && <DownloadStoreStatus is_downloaded={item.is_downloaded} />}
        </>
      ) : <span>Pilih toko</span>}
    </DropdownStoreItemStyle>
  )
}